export default "__VITE_ASSET__ZsqPofSd__"